import PageLoaderService from '../ts/service/page-loader-service.ts';

PageLoaderService.init();

const serpDependencies = [
  'ngSanitize',
  'jrCommonDirective',
  'jrCommonService',
  'jrCommonController',
  'jrSerpItem',
  'jrPagination',
  'jrAutocompleteEmail',
  'jrCookieConsent',
  'jrFavouriteJobsModule',
  'jrLocationInput',
  'jrRegistration',
  'jrInlineProposal',
  'jrProposal',
  'jrSerpAdvert',
  'ngAnimate',
  'ui.bootstrap',
];

angular.module('jrSerp', serpDependencies, [
  '$interpolateProvider',
  function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
  },
]);
